// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"349":"5ba323b4","775":"5ee64d8a","799":"9e648d11"}[chunkId] + ".css";
};